import React from 'react';

export default({ message }) => {
  return (
    <div className="relative bg-brown-700">
      <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="pr-16 sm:text-center sm:px-16">
          <p className="font-medium text-white">
            <span className="md:hidden">
              {message}
            </span>
            <span className="hidden md:inline">
              {message}
            </span>
          </p>
        </div>
        <div className="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
        </div>
      </div>
    </div>
  );
}